module.exports = __webpack_public_path__ + "media/images/icons/pencil-a577270094ffd6f07bf7508606fc4c5b.svg";